import styled from "styled-components";

export const BG = "radial-gradient(1200px 700px at 20% 10%, rgba(92,233,255,.18), transparent 60%), radial-gradient(900px 500px at 85% 35%, rgba(0,247,210,.14), transparent 55%), linear-gradient(180deg, #070A12 0%, #060813 60%, #050610 100%)";

export const PageContainer = styled.div`
  min-height: 100vh;
  background: ${BG};
  color: rgba(240,250,255,.92);
  font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial;
`;

export const MaxWidthContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

export const TopBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 14px 14px 10px;
`;

export const StickyTopBar = styled.div`
  position: sticky;
  top: 0;
  z-index: 20;
  backdrop-filter: blur(10px);
  background: linear-gradient(180deg, rgba(5,6,16,.70), rgba(5,6,16,.35));
  border-bottom: 1px solid rgba(92,233,255,.10);
`;

export const MainGrid = styled.div`
  display: grid;
  grid-template-columns: 360px 1fr;
  gap: 12px;

  @media (max-width: 980px) {
    grid-template-columns: 1fr;
  }
`;

export const SideNavContainer = styled.div`
  display: grid;
  gap: 10px;
  padding: 14px;
`;

export const MainContent = styled.div`
  padding: 14px;
`;

export const FooterNote = styled.div`
  padding: 14px;
  color: rgba(210,235,245,.65);
  font-size: 12px;
`;

export const AvatarContainer = styled.div`
  width: ${props => props.size || 44}px;
  height: ${props => props.size || 44}px;
  border-radius: ${props => props.borderRadius || 14}px;
  overflow: hidden;
  border: 1px solid rgba(92,233,255,.18);
  background: linear-gradient(180deg, rgba(92,233,255,.18), rgba(0,247,210,.10));
  display: grid;
  place-items: center;
`;

export const IconContainer = styled.div`
  width: ${props => props.size || 34}px;
  height: ${props => props.size || 34}px;
  border-radius: ${props => props.borderRadius || 12}px;
  display: grid;
  place-items: center;
  color: rgba(220,250,255,.95);
  background: radial-gradient(circle at 30% 20%, rgba(92,233,255,.22), rgba(0,0,0,0) 60%), linear-gradient(180deg, rgba(0,247,210,.14), rgba(92,233,255,.08));
  border: 1px solid rgba(92,233,255,.16);
`;

export const Card = styled.div`
  border-radius: 18px;
  padding: 16px;
  background: linear-gradient(180deg, rgba(255,255,255,.06), rgba(255,255,255,.03));
  border: 1px solid rgba(92,233,255,.14);
  box-shadow: 0 18px 50px rgba(0,0,0,.35);
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
`;

export const CardHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const CardTitle = styled.div`
  font-weight: 800;
  letter-spacing: .2px;
`;

export const Button = styled.button`
  height: 38px;
  padding: 0 12px;
  border-radius: 12px;
  border: 1px solid rgba(92,233,255,.16);
  background: ${props => {
    if (props.variant === "pri") return "linear-gradient(90deg, rgba(92,233,255,.95), rgba(0,247,210,.92))";
    if (props.variant === "sec") return "linear-gradient(180deg, rgba(255,255,255,.08), rgba(255,255,255,.04))";
    if (props.variant === "danger") return "linear-gradient(90deg, rgba(255,92,163,.22), rgba(255,92,92,.14))";
    return "rgba(255,255,255,.06)";
  }};
  color: ${props => props.variant === "pri" ? "#041018" : "rgba(240,250,255,.92)"};
  font-weight: 800;
  cursor: ${props => props.disabled ? "not-allowed" : "pointer"};
  opacity: ${props => props.disabled ? 0.55 : 1};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: ${props => props.variant === "pri" ? "0 14px 38px rgba(0,247,210,.14)" : "0 8px 20px rgba(0,0,0,.2)"};
  }

  ${props => props.variant === "pri" && `
    border: 1px solid rgba(92,233,255,.30);
    box-shadow: 0 14px 38px rgba(0,247,210,.14);
  `}

  ${props => props.variant === "danger" && `
    border: 1px solid rgba(255,92,163,.22);
  `}
`;

export const Field = styled.label`
  display: grid;
  gap: 8px;
`;

export const FieldLabel = styled.span`
  font-size: 12px;
  color: rgba(210,235,245,.8);
  font-weight: 800;
`;

export const Input = styled.input`
  width: 100%;
  height: 40px;
  border-radius: 12px;
  padding: ${props => props.hasRight ? "0 44px 0 12px" : "0 12px"};
  border: 1px solid rgba(92,233,255,.14);
  background: rgba(0,0,0,.22);
  color: rgba(240,250,255,.92);
  outline: none;
  opacity: ${props => props.disabled ? 0.65 : 1};
  cursor: ${props => props.disabled ? "not-allowed" : "text"};

  &:focus {
    border-color: rgba(92,233,255,.30);
    box-shadow: 0 0 0 3px rgba(92,233,255,.10);
  }
`;

export const InputWrapper = styled.div`
  position: relative;
`;

export const InputRight = styled.div`
  position: absolute;
  right: 8px;
  top: 6px;
`;

export const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 14px;
  border: 1px solid rgba(92,233,255,.12);
  background: rgba(0,0,0,.20);
`;

export const ToggleLabel = styled.div`
  display: grid;
  gap: 4px;
`;

export const ToggleTitle = styled.div`
  font-weight: 900;
`;

export const ToggleHint = styled.div`
  font-size: 12px;
  color: rgba(210,235,245,.72);
`;

export const ToggleSwitch = styled.button`
  width: 52px;
  height: 30px;
  border-radius: 999px;
  border: 1px solid rgba(92,233,255,.16);
  background: ${props => props.checked ? "linear-gradient(90deg, rgba(92,233,255,.95), rgba(0,247,210,.90))" : "rgba(255,255,255,.06)"};
  position: relative;
  cursor: pointer;
  transition: all .18s ease;
`;

export const ToggleThumb = styled.span`
  position: absolute;
  top: 4px;
  left: ${props => props.checked ? 26 : 4}px;
  width: 22px;
  height: 22px;
  border-radius: 999px;
  background: ${props => props.checked ? "#041018" : "rgba(240,250,255,.92)"};
  transition: all .18s ease;
`;

export const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  border-radius: 999px;
  background: ${props => {
    if (props.tone === "a") return "linear-gradient(90deg, rgba(92,233,255,.22), rgba(0,247,210,.14))";
    if (props.tone === "b") return "linear-gradient(90deg, rgba(255,198,92,.18), rgba(255,92,163,.12))";
    if (props.tone === "c") return "linear-gradient(90deg, rgba(180,92,255,.18), rgba(92,143,255,.12))";
    return "linear-gradient(90deg, rgba(92,255,160,.18), rgba(92,233,255,.10))";
  }};
  border: 1px solid rgba(92,233,255,.18);
  color: rgba(240,250,255,.92);
  font-size: 12px;
  white-space: nowrap;
`;

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.62);
  backdrop-filter: blur(6px);
  display: grid;
  place-items: center;
  padding: 14px;
  z-index: 50;
`;

export const ModalContainer = styled.div`
  width: min(720px, 100%);
  border-radius: 18px;
  border: 1px solid rgba(92,233,255,.18);
  background: linear-gradient(180deg, rgba(10,12,20,.96), rgba(6,7,15,.94));
  box-shadow: 0 24px 80px rgba(0,0,0,.55);
  overflow: hidden;
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px;
  border-bottom: 1px solid rgba(92,233,255,.10);
`;

export const ModalTitle = styled.div`
  font-weight: 900;
`;

export const ModalCloseButton = styled.button`
  width: 34px;
  height: 34px;
  border-radius: 12px;
  border: 1px solid rgba(92,233,255,.14);
  background: rgba(255,255,255,.06);
  color: rgba(240,250,255,.9);
  cursor: pointer;
  display: grid;
  place-items: center;
`;

export const ModalBody = styled.div`
  padding: 14px;
`;

export const ModalFooter = styled.div`
  padding: 14px;
  border-top: 1px solid rgba(92,233,255,.10);
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  flex-wrap: wrap;
`;

export const ToastStack = styled.div`
  position: fixed;
  right: 14px;
  bottom: 14px;
  display: grid;
  gap: 10px;
  z-index: 60;
  width: min(360px, calc(100vw - 28px));
`;

export const Toast = styled.div`
  border-radius: 16px;
  padding: 12px;
  border: 1px solid rgba(92,233,255,.16);
  background: linear-gradient(180deg, rgba(255,255,255,.08), rgba(255,255,255,.04));
  box-shadow: 0 18px 60px rgba(0,0,0,.4);
`;

export const ToastHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
`;

export const ToastTitle = styled.div`
  font-weight: 900;
`;

export const ToastDismiss = styled.button`
  border: none;
  background: transparent;
  color: rgba(240,250,255,.85);
  cursor: pointer;
`;

export const ToastMessage = styled.div`
  margin-top: 6px;
  font-size: 12px;
  color: rgba(210,235,245,.78);
`;

export const SecurityConsole = styled.div`
  border-radius: 18px;
  border: 1px solid rgba(92,233,255,.14);
  background: linear-gradient(180deg, rgba(255,255,255,.06), rgba(255,255,255,.03));
  overflow: hidden;
`;

export const SecurityConsoleHeader = styled.div`
  padding: 12px;
  border-bottom: 1px solid rgba(92,233,255,.10);
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SecurityConsoleContent = styled.div`
  display: grid;
  gap: 8px;
  padding: 12px;
`;

export const NavButton = styled.button`
  text-align: left;
  width: 100%;
  border-radius: 14px;
  padding: 10px 10px;
  border: 1px solid rgba(92,233,255,.12);
  background: ${props => props.active ? "linear-gradient(90deg, rgba(92,233,255,.22), rgba(0,247,210,.12))" : "rgba(0,0,0,.18)"};
  color: rgba(240,250,255,.92);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  transition: all 0.2s ease;

  &:hover {
    background: ${props => props.active ? "linear-gradient(90deg, rgba(92,233,255,.22), rgba(0,247,210,.12))" : "rgba(255,255,255,.06)"};
  }
`;

export const NavButtonLeft = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 10px;
`;

export const NavButtonIcon = styled.span`
  width: 30px;
  height: 30px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  border: 1px solid rgba(92,233,255,.14);
  background: rgba(255,255,255,.06);
`;

export const NavButtonLabel = styled.b`
  letter-spacing: .2px;
`;

export const NavButtonRight = styled.span`
  opacity: ${props => props.active ? 1 : 0.55};
`;

export const Grid2 = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0,1fr));
  gap: 12px;

  @media (max-width: 980px) {
    grid-template-columns: 1fr;
  }
`;

export const Grid3 = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0,1fr));
  gap: 12px;

  @media (max-width: 980px) {
    grid-template-columns: 1fr;
  }
`;

export const Grid4 = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0,1fr));
  gap: 12px;

  @media (max-width: 980px) {
    grid-template-columns: 1fr;
  }
`;

export const TableContainer = styled.div`
  border-radius: 16px;
  border: 1px solid rgba(92,233,255,.12);
  overflow: hidden;
`;

export const TableHeader = styled.div`
  display: grid;
  grid-template-columns: ${props => props.columns || "170px 110px 140px 1fr 110px"};
  gap: 0;
  padding: 10px;
  border-bottom: 1px solid rgba(92,233,255,.10);
  background: rgba(0,0,0,.22);
  font-size: 12px;
  color: rgba(210,235,245,.8);
  font-weight: 900;
`;

export const TableRow = styled.div`
  display: grid;
  grid-template-columns: ${props => props.columns || "170px 110px 140px 1fr 110px"};
  gap: 0;
  padding: 10px;
  border-top: 1px solid rgba(92,233,255,.08);
  background: rgba(255,255,255,.02);
`;

export const TableCell = styled.div`
  font-size: 12px;
  color: ${props => props.bold ? "rgba(240,250,255,.88)" : "rgba(210,235,245,.82)"};
  font-weight: ${props => props.bold ? 800 : 400};
`;

export const ContentGrid = styled.div`
  display: grid;
  gap: 12px;
`;

export const SectionBox = styled.div`
  border-radius: 16px;
  border: 1px solid rgba(92,233,255,.12);
  background: rgba(0,0,0,.20);
  padding: 12px;
  display: grid;
  gap: ${props => props.gap || 10}px;
`;

export const ProgressRingContainer = styled.svg`
  display: block;
`;

export const ProgressRingCircle = styled.circle.attrs(props => ({
  strokeDasharray: `${props.dash || 0} ${(props.circumference || 0) - (props.dash || 0)}`,
}))`
  stroke: ${props => props.stroke || "rgba(92,233,255,.95)"};
  fill: none;
  stroke-width: 5;
  stroke-linecap: round;
  transform: rotate(-90 24 24);
`;

export const ProgressRingText = styled.text`
  text-anchor: middle;
  font-size: 12px;
  fill: rgba(240,250,255,.9);
  font-weight: 800;
`;

export const OTPContainer = styled.div`
  display: grid;
  gap: 8px;
`;

export const OTPInputs = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

export const OTPInput = styled.input`
  width: 44px;
  height: 44px;
  border-radius: 14px;
  text-align: center;
  border: 1px solid rgba(92,233,255,.16);
  background: rgba(0,0,0,.22);
  color: rgba(240,250,255,.92);
  outline: none;
  font-weight: 900;
  font-size: 16px;
`;

export const OTPHint = styled.div`
  font-size: 12px;
  color: rgba(210,235,245,.68);
`;

export const CoverImage = styled.div`
  position: relative;
  height: 160px;
  border-radius: 18px;
  overflow: hidden;
  border: 1px solid rgba(92,233,255,.18);
  background: ${props => props.src ? `url(${props.src}) center/cover no-repeat` : "linear-gradient(120deg, rgba(92,233,255,.25), rgba(0,247,210,.12))"};
`;

export const CoverPlaceholder = styled.div`
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  color: rgba(240,250,255,.85);
  font-weight: 900;
`;

export const AvatarGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(8, minmax(0,1fr));
  gap: 10px;
`;

export const AvatarPresetButton = styled.button`
  width: 44px;
  height: 44px;
  border-radius: 14px;
  border: ${props => props.active ? "1px solid rgba(92,233,255,.55)" : "1px solid rgba(92,233,255,.14)"};
  background: rgba(0,0,0,.22);
  overflow: hidden;
  cursor: pointer;
  box-shadow: ${props => props.active ? "0 0 0 3px rgba(92,233,255,.14)" : "none"};
  padding: 0;
`;

export const GalleryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(6, minmax(0,1fr));
  gap: 10px;
`;

export const GalleryItem = styled.div`
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid rgba(92,233,255,.14);
`;

export const GalleryAddButton = styled.label`
  border-radius: 14px;
  border: 1px dashed rgba(92,233,255,.25);
  height: 90px;
  display: grid;
  place-items: center;
  cursor: pointer;
`;

export const FileInput = styled.input`
  display: none;
`;

export const FileInputLabel = styled.label`
  cursor: pointer;
`;
